import "./Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Home = () => {
    return <section className="Home">
        <FontAwesomeIcon icon="fa-brands fa-youtube" />
        <p><strong>Alimento para tu alma</strong> es un canal que tiene como objetivo difundir y predicar la palabra de Dios como Jesús la predicó en la tierra. Queremos hacer conciencia en las personas para la búsqueda verdadera de Dios y no de una pertenencia a un grupo o denominación. No promovemos ningún tipo de religión salvo "La religión pura y sin mácula delante de Dios el Padre" Santiago 1:27 RVR1960.</p>
        <a href="https://youtube.com/@alimentoparatualmaorg" target="_blank">Visitar nuestro canal</a>
    </section>
}